import { render, staticRenderFns } from "./articleTab.vue?vue&type=template&id=587c04e5"
import script from "./articleTab.vue?vue&type=script&lang=js"
export * from "./articleTab.vue?vue&type=script&lang=js"
import style0 from "./articleTab.vue?vue&type=style&index=0&id=587c04e5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports